import { AttendanceBalance } from 'generated/resources/graphql'
import { DeepPartial } from 'utility-types'

class BalanceUtils {
  static toDateKey(date: Date) {
    const pad = (value: number) => String(value).padStart(2, '0')

    return [date.getFullYear(), pad(date.getMonth() + 1), pad(date.getDate())].join('-')
  }

  static aggregateDailyBalanceFromPlanning({
    from,
    to,
    balances,
  }: {
    from: Date
    to: Date
    balances?: Array<
      Pick<AttendanceBalance, 'dailyBalanceFromPlanning'> & DeepPartial<AttendanceBalance>
    > | null
  }): number {
    if (!balances || balances.length === 0) return 0

    const fromKey = this.toDateKey(from)
    const toKey = this.toDateKey(to)

    return balances.reduce((accumulator, balance) => {
      if (!balance.date) return accumulator

      if (balance.date < fromKey || balance.date > toKey) return accumulator

      const minutes = Number(balance.dailyBalanceFromPlanning)
      return Number.isFinite(minutes) ? accumulator + minutes : accumulator
    }, 0)
  }

  static aggregateDailyBalance({
    from,
    to,
    balances,
  }: {
    from: Date
    to: Date
    balances?: Array<
      Pick<AttendanceBalance, 'dailyBalance'> & DeepPartial<AttendanceBalance>
    > | null
  }): number {
    if (!balances || balances.length === 0) return 0

    const fromKey = this.toDateKey(from)
    const toKey = this.toDateKey(to)

    return balances.reduce((accumulator, balance) => {
      if (!balance.date) return accumulator

      if (balance.date < fromKey || balance.date > toKey) return accumulator

      const minutes = Number(balance.dailyBalance)
      return Number.isFinite(minutes) ? accumulator + minutes : accumulator
    }, 0)
  }
}

export default BalanceUtils
